// extracted by mini-css-extract-plugin
module.exports = {"link":"_1qQcj","root":"_3gd2d","label":"kkTLe"};